export default __webpack_public_path__ + "edd64c4d39045e9d8b0d45c2233874c1.png";